import getTableRowCountForCells from '../utils/getTableRowCountForCells';
import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
export default function removeTableRow(editor, tableId, rowIndex) {
  var cells = editor.getTableCells(tableId);
  var table = editor.value.document.getParent(cells.first().key);
  var rowCount = getTableRowCountForCells(cells);
  var columnCount = getTableColumnCountForCells(cells);

  if (rowIndex >= rowCount) {
    throw new Error('Wrong table row deletion index');
  }

  if (rowCount === 1) {
    return editor.deselectTable().withoutNormalizing(function () {
      editor.removeNodeByKey(table.key);
    });
  }

  var firstCellIndex = table.getPath(cells.first().key).last();
  var deletionIndex = firstCellIndex + rowIndex * columnCount;
  return editor.withoutNormalizing(function () {
    for (var i = 0; i < columnCount; i++) {
      var index = deletionIndex + i;
      var cell = table.getNode([index]);
      editor.removeNodeByKey(cell.key);
    }
  }).deselectTable();
}